import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';
import { Models } from '@ibexfusion/models';
import { DialogService } from '@services/dialog/dialog.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupService } from '@services/groups/group.service';
import { PackageService } from '@services/packages/package.service';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import moment from 'moment';
import * as _ from 'lodash';
import { GroupHasSecuredAppService } from '@services/groups/group-has-secured-app.service';
import { LabelsService } from '@services/labels/labels.service';
import { TranslateService } from '@services/translate/translate.service';
import { FrontProfileExportWizardComponent } from '../../components/popUpSelects/front-profile-export-wizard/front-profile-export-wizard.component';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalProfileDataService } from '@services/additional-profile-data/additional-profile-data.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { VoucherActivityService } from '@services/voucher-activity/voucher-activity.service';
import { Services } from '@ibexfusion/core-utils';

@Component({
    selector: 'app-front-profiles',
    templateUrl: './front-profiles.component.html',
    styleUrls: ['./front-profiles.component.scss'],
    providers: [
        FrontProfilesService, GroupService, GroupHasRoleInOrganisationService, PackageService, GroupHasSecuredAppService, AdditionalProfileDataService, PackageInstalledAppsService,
        DynamicContentEntranceService, VoucherActivityService
    ],
    standalone: false
})
export class FrontProfilesComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  @ViewChild('labelTable') labelTable: DataTableComponent;

  public title = 'Users';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'firstName', translationString: 'myUsers.firstName' }, { prop: 'lastName', translationString: 'myUsers.lastName' },
    { prop: 'email', translationString: 'myUsers.email' }, { prop: 'mobile', translationString: 'myUsers.mobile' },
    {
      prop: 'isActivated', chip: true, translationPrefix: 'myUsers.states.', sortField: 'lastSeen', valueCallback: this.checkActiveAndLastSeen,
      translationString: 'myUsers.isActivated', hover: function(data) {
        return data.lastSeen ? moment(data.lastSeen).format('DD.MM.YYYY - HH:mm') : null;
      }
    }
  ];

  public searchColumns = [
    { prop: 'firstName', translationString: 'myUsers.firstName' }, { prop: 'lastName', translationString: 'myUsers.lastName' },
    { prop: 'email', translationString: 'myUsers.email' }, { prop: 'mobile', translationString: 'myUsers.mobile' }
  ];

  public groupColumns = [{ prop: 'name' }];
  params: any;

  checkBoxActions: any[];

  groupParams: any = {};
  chatGroupParams: any = {};
  labelParams;
  labelColumns = [{ prop: 'title' }];
  myPackage: Models.Package;
  isChatModuleAdmin = false;
  frontProfilesCount = 0;
  chatProfilesCount = 0;
  chatGroupIds = [];
  groupIds = [];
  labels: Models.Label[];
  translationsAll;
  translations;
  isLoading = false;

  constructor(
    public frontProfilesService: FrontProfilesService, public groupService: GroupService, private router: Router, private route: ActivatedRoute, private snackbar: SnackbarService,
    private dialogService: DialogService, private ghrioService: GroupHasRoleInOrganisationService, public labelService: LabelsService, private packageService: PackageService,
    private messengerService: MessengerService, public groupHasFrontProfileService: GroupHasFrontProfileService, private translate: TranslateService, private dialog: MatDialog,
    private additionalDataService: AdditionalProfileDataService, private appService: PackageInstalledAppsService, private entranceService: DynamicContentEntranceService,
    private voucher: VoucherActivityService
  ) {
    this.params = { isAnonymous: false, packageId: this.route.snapshot.params['packageId'], $sort: { lastName: 1 } };
    this.labelParams = { packageId: this.route.snapshot.params['packageId'] };
    this.init();
  }

  async init() {
    this.translationsAll = this.translate.get();
    this.translations = this.translationsAll['myUsers'];
    this.checkBoxActions = [
      {
        title: this.translations.exportUsersTitle, icon: 'cloud_download',
        callback: (profiles: Models.FrontProfileModel[]) => {
          this.startExportWizard(profiles);
        }
      },
      {
        title: this.translations.removeUsersTitle, icon: 'delete', idField: 'FrontProfileID',
        callback: (ids: string[]) => {
          this.startDeleteUsers(ids);
        }
      },
      {
        title: this.translations.invitationLinkTitle, icon: 'email',
        callback: (elements: Models.FrontProfileModel[]) => {
          this.sendInvitationMails(elements);
        }
      }
    ]
  }

  async startDeleteUsers(ids: string[]) {
    let text = this.translations.removeUsersRequestTextMulti1 + ' ' + ids.length + ' ' + this.translations.removeUsersRequestTextMulti2;
    if (ids.length === 1) {
      text = this.translations.removeUsersRequestTextSingle
    }
    const dialogRes = await this.dialogService.confirm(text, this.translations.removeUsersRequestTitle);
    if (dialogRes !== true) {
      return Promise.resolve();
    }
    for (const id of ids) {
      await this.frontProfilesService.remove(id);
    }
    this.dataTable.unselectAll();
    return this.dataTable.page();
  }

  async sendInvitationMails(elements: Models.FrontProfileModel[]) {
    let text = this.translations.invitationLinkRequestTextMulti1 + ' ' + elements.length + ' ' + this.translations.invitationLinkRequestTextMulti2;
    if (elements.length === 1) {
      text = this.translations.invitationLinkRequestTextSingle
    }
    const dialogRes = await this.dialogService.confirm(text, this.translations.invitationLinkRequestTitle);
    if (dialogRes !== true) {
      return Promise.resolve();
    }
    for (const profile of elements) {
      await this.frontProfilesService.update(profile.FrontProfileID, profile, { query: { invitationMail: true } });
    }
    this.dataTable.unselectAll();
    return this.dataTable.page();
  }

  async ngOnInit() {
    this.createPageActions();
    const myPackage = await this.packageService.get(this.route.snapshot.params['packageId']);
    const apps = await this.appService.find(0, myPackage.installedAppIds.length, { _id: { $in: myPackage.installedAppIds } });
    const entrances = await this.entranceService.find(0, apps.data.length, { _id: { $in: apps.data.map(el => el.dynamicContentEntranceId).filter(el => !!el) } });
    const dynamicContentIds = entrances.data.filter(el => el.type === 'voucher').reduce((accumulator, currentObject) => accumulator.concat(currentObject.children), []);
    const voucherData = await this.voucher.find(0, 10000, {voucherId: { $in: dynamicContentIds }, redeemed: { $exists: true }});
    if (!!dynamicContentIds?.length) {
      this.columns.splice(4, 0, { prop: 'usedVouchers', chip: false, translationPrefix: 'myUsers.', sortField: 'usedVouchers', valueCallback: this.getVoucherCount, translationString: 'myUsers.usedVouchers', additionalData: voucherData.data } as any)
    }
    const labels = await this.labelService.find(0, 100, { packageId: this.route.snapshot.params['packageId'] });
    this.labels = labels.data;
    this.myPackage = myPackage;
    this.groupIds = await this.getGroupIds();
    if (this.groupIds?.length) {
      this.groupParams = { GroupID: { $in: this.groupIds } };
    }
    this.chatGroupIds = await this.getGroupIds(true);
    if (this.chatGroupIds?.length) {
      this.chatGroupParams = { GroupID: { $in: this.chatGroupIds } };
    }
    this.getProfilCounts();
  }

  async getGroupIds(getAddressBooks = false): Promise<string[]> {
    const roles: string[] = _.map(this.messengerService.$activeRoles.getValue(), 'roleName');
    if (!roles.includes('myUserManager')) {
      return;
    }
    let roleNames: string[] = [];
    if (getAddressBooks) {
      if (roles.includes('chatModuleAdmin')) {
        roleNames = ['chatModule', 'chatModuleGroupAdmin'];
      }
    } else {
      roleNames = roleNames.concat(roles.includes('securedContentAdmin') ? ['securedContent'] : []);
      roleNames = roleNames.concat(roles.includes('ticketingModuleAdmin') ? ['ticketingModule', 'ticketingModuleEditor'] : []);
      roleNames = roleNames.concat(roles.includes('orderModuleAdmin') ? ['orderModule'] : []);
    }
    if (!roleNames?.length) {
      return [];
    }
    const groups = await this.ghrioService.find(0, 100, { roleName: { $in: roleNames }, OrganisationID: this.messengerService.$activeOrganisation.getValue().OrganisationID });
    return groups.data.map(el => el.GroupID);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate([event.row.FrontProfileID], { relativeTo: this.route });
  }

  public onEditGroup(event: DataTableEvent): void {
    this.router.navigate(['group', event.row.GroupID], { relativeTo: this.route });
  }

  public onEditLabel(event: DataTableEvent): void {
    this.router.navigate(['label', event.row._id], { relativeTo: this.route });
  }

  public async onRemove(event: DataTableEvent): Promise<any> {
    const dialogRef = await this.dialogService.confirm('Diesen Benutzer wirklich löschen?');
    if (!dialogRef) {
      return;
    }
    await this.frontProfilesService.remove(event.row.FrontProfileID).catch(error => {
      const message = (error.error.message ? error.error.message : error.message);
      return this.dialogService.confirm(message, error.name);
    });
    this.dataTable.refresh();
    this.getProfilCounts();
    this.snackbar.success('Benutzer gelöscht');
  }

  public async onRemoveLabel(event: DataTableEvent): Promise<any> {
    const frontProfiles = await this.frontProfilesService.find(0, 1000, { labelIds: { $like: '%' + event.row._id + '%' } });
    const res = await this.dialogService.confirm('Dieses Label wirklich löschen?' + (!!frontProfiles?.data?.length ? ' Das Label ist noch mindestens einem User zugewiesen' : ''));
    if (!res) {
      return;
    }
    for (const profile of frontProfiles.data) {
      profile.labelIds = profile.labelIds.split(',').filter(el => el !== event.row._id).join(',');
      await this.frontProfilesService.patch(profile.FrontProfileID, { labelIds: profile.labelIds });
    }
    await this.labelService.remove(event.row._id);
    this.labels.splice(event.index, 1);
    this.labelTable.refresh();
    this.snackbar.success('Label gelöscht');
  }

  filterByLabel(tab: any) {
    if (tab.index === 0) {
      delete this.params['labelIds'];
    } else {
      this.params['labelIds'] = { $like: '%' + this.labels[tab.index - 1]._id + '%' }
    }
    this.dataTable.page();
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'New user',
        translationString: 'myUsers.new',
        callback: () => {
          this.router.navigate(['create'], { relativeTo: this.route });
        }
      })
    ];
  }

  private startExportWizard(profiles) {
    const dialogRef = this.dialog.open(FrontProfileExportWizardComponent, { data: { packageId: this.route.snapshot.params['packageId'] }, width: '800px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.length) {
        const fields = result.filter(el => el.selected);
        this.generateExcel(fields, profiles);
      }
    });
  }

  private async generateExcel(fields: any[], profiles: Models.FrontProfileModel[]) {
    this.isLoading = true;
    let labels;
    if (fields.find(el => el.name === 'labels')) {
      labels = await this.labelService.find(0, 100, { packageId: this.route.snapshot.params['packageId'] });
    }
    const finalProfiles = [];
    if (profiles && profiles.length) {
      for (const profile of profiles) {
        const finalProfile = {};
        let additionalData;
        if (profile.additionalDataId) {
          additionalData = await this.additionalDataService.get(profile.additionalDataId);
        }
        for (const field of fields) {
          if (additionalData && additionalData.data && additionalData.data[field.name]) {
            finalProfile[field.name] = additionalData.data[field.name];
          } else if (field.name === 'state') {
            finalProfile[field.name] = this.translations.states[await this.checkActiveAndLastSeen(profile)];
          } else if (field.name === 'labels' && profile.labelIds && profile.labelIds.split(',') && profile.labelIds.split(',').length) {
            finalProfile[field.name] = profile.labelIds.split(',').filter(el => !!el).map(el => {
              return labels.data.find(label => label._id === el)
            }).map(el => el.title).join(', ');
          } else {
            finalProfile[field.name] = profile[field.name];
          }
        }
        finalProfiles.push(finalProfile);
      }
    }
    const data = [];
    const header = [];
    for (const field of fields) {
      header.push(field.title || _.get(this.translationsAll, field.translation));
    }
    data.push(header);
    for (const profile of finalProfiles) {
      data.push(fields.map(el => profile[el.name]))
    }
    const csvContent = 'data:text/csv;charset=utf-8,' + data.map(row => row.join('\t')).join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'profile-export-' + moment().format('DD-MM-YYYY HH-mm-ss') + '.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.isLoading = false;
  }

  checkActiveAndLastSeen(data: Models.FrontProfileModel, additionalData?): any {
    if (!data.isActivated && !data.lastSeen) {
      return 'red';
    } else {
      const date = moment().milliseconds(0).seconds(0).minutes(0).hours(0);
      const lastSeen = moment(data.lastSeen);
      date.subtract(30, 'd');
      if (date < lastSeen) {
        return 'green';
      }
      date.subtract(30, 'd');
      if (date < lastSeen) {
        return 'yellow';
      }
      date.subtract(30, 'd');
      if (date < lastSeen) {
        return 'orange';
      } else {
        return 'dark-orange';
      }
    }
  }

  getVoucherCount(data: Models.FrontProfileModel, additionalData?: any): any {
    const profileId = Services.HashIdService.unhashSingle(data.FrontProfileID);
    return additionalData.filter(el => el.profileId === profileId.toString()).length;
  }

  checkLimit(limit, count): string {
    if (count >= limit) {
      return 'reached';
    }
    return (count >= limit - (limit <= 100 ? 0.1 : 0.05) * limit) ? 'warn' : null;
  }

  private async getProfilCounts() {
    const groupRes = await this.groupHasFrontProfileService.find(0, this.myPackage.ibexApp.allowedFrontProfiles || 100, { GroupID: { $in: this.chatGroupIds } });
    this.chatProfilesCount = Object.keys(_.countBy(groupRes.data, el => { return el.ProfileID })).length;
    const profileRes = await this.frontProfilesService.find(0, 1, this.params);
    this.frontProfilesCount = profileRes.total;
  }
}
